<ng-template #load>
  <ng-container *ngIf="!errorFound; else failed">
    <div class="text-center blink mt-5">Loading...</div>
  </ng-container>
</ng-template>

<ng-template #failed>
  <div class="text-center mt-5">{{error}}</div>
</ng-template>

<div class="tripspage" >
  
    <div class="page-header">
        <h2>Trips </h2>
        <div class="toolbar" style="justify-content: flex-start;">
          <div ngbDropdown class="custom_dropdown">
              <button class="btn" ngbDropdownToggle *ngIf="domain">{{domain|t}}</button>
              <button class="btn" ngbDropdownToggle *ngIf="!domain">Loading</button>
              <div ngbDropdownMenu>
              <button ngbDropdownItem *ngFor="let d of domains" (click)="domain = d">{{d|t}}</button>
              </div>
          </div>
      
          <div class="form-group" style="width: 140px;">
              <div class="input-group input-group-sm">
              <input class="form-control" placeholder="dd/mm/yyyy" readonly name="dp1" [(ngModel)]="from" ngbDatepicker #d1="ngbDatepicker" (dateSelect)="setFrom($event)">
              <div class="input-group-append">
                  <button class="btn btn-outline-secondary " (click)="d1.toggle()" type="button"><i class="fas fa-calendar-alt"></i></button>
              </div>
              </div>
          </div>
      
          <div class="form-group" style="width: 140px;">
              <div class="input-group input-group-sm">
              <input class="form-control" placeholder="dd/mm/yyyy" readonly name="dp2" [(ngModel)]="until" ngbDatepicker #d2="ngbDatepicker" (dateSelect)="setUntil($event)">
              <div class="input-group-append">
                  <button class="btn btn-outline-secondary " (click)="d2.toggle()" type="button"><i class="fas fa-calendar-alt"></i></button>
              </div>
              </div>
          </div>
      
          <div ngbDropdown class="custom_dropdown">
              <button class="btn" ngbDropdownToggle>{{target && !target.label.includes('null') ? target.label : 'Anonymous User'}}</button>
              <div ngbDropdownMenu>
              <button ngbDropdownItem *ngFor="let u of users" (click)="setTargetUser(u)">
                  {{ u.first_name + u.last_name != '' ? u.first_name + ' ' + u.last_name : 'Anonymous User' }}
              </button>
              </div>
          </div>
        </div>
    </div>
    <div class="page-content">
      <div class="sidebar">

        <ng-container *ngFor="let menuItem of menu">
        <ng-container *ngIf="menuItem.label == domain">
    
            <div class="menuitem-wrapper">
              <span style="position: absolute; right: 10px; font-size: 14px;">Score</span>
              <div style="margin-top: 4px; margin-bottom: 5px;" *ngFor="let subMenuItem of menuItem.children">
                <div class="boldtitle d-flex" *ngIf="subMenuItem.children.length">
                  <div class="flex-grow-1">{{subMenuItem.name|t}}</div>
                </div>
                <div class="subparams">
                  <div
                      *ngFor="let sub2menuitem of subMenuItem.children"
                      class="pointer w-100 d-inline-block"
                      >
                      <label class="submenu-item">
                      <input 
                          *ngIf="isMapOpen"
                          type="checkbox" 
                          name="checkbox" 
                          value="{{subMenuItem.label + '/' +sub2menuitem.label}}"
                          (change)="onFilterChange($event)" />
                      <div class="submenu-item-label-wrapper" [ngStyle]="{ 'background-color': subMenuItem.color, 'cursor': 'pointer' }">
                          <span class="flex-span">
                          <img src={{sub2menuitem.icon}} class="icon-img" width="24" height="24" />
                          <span *ngIf="selected" class="subparam-count">{{sub2menuitem.count}}</span>
                          <span>{{sub2menuitem.name|t}}</span>
                          </span>
                          <span *ngIf="selected" class="score">{{sub2menuitem.score | number:'1.0-0'}}</span>
                      </div>
                      </label>
                  </div>
                </div>
              </div>
            </div>
        </ng-container>
        </ng-container>
      </div>
    
      <div class="resultscontainer">
        <ng-container *ngIf="!loader && !errorFound; else load">
          <div class="container-content">
              <div class="tripscontainer" *ngIf="!isMapOpen">
              <div class="trips-table-wrapper">
                  <table>
                  <thead style="background-color: white;">
                      <tr>
                      <th></th>
                      <th><span class="events-number">{{trips.length}} trips</span></th>
                      <th style="cursor: pointer" (click)="toggleSort('date')">Date <i class="fa fa-sort"
                        aria-hidden="true"></i></th>
                      <th>Start</th>
                      <th>End</th>
                      <th style="cursor: pointer" (click)="toggleSort('duration')">Duration<i
                        class="fa fa-sort" aria-hidden="true"></i></th>
                      <th style="cursor: pointer" (click)="toggleSort('distance')">Km<i
                        class="fa fa-sort" aria-hidden="true"></i></th>
                      <th></th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr 
                          *ngFor="let trip of filterTrips() | paginate: { itemsPerPage: pageSize,currentPage: p}" 
                          id="{{trip.trip_uuid}}" 
                          [ngClass]="{'selected': selected && trip.trip_uuid===selected.trip_uuid}"
                          (click)="selectTrip(trip)"
                          >
                          <td class="no-header"></td>
                          <td>
                              <img (click)="setMapOpen(true, trip)" src="assets/images/distance_mark.svg" width="40" height="40" />
                          </td>
                          <td>{{ trip.date }}</td>
                          <td>{{ trip.start }}</td>
                          <td>{{ trip.end }}</td>
                          <td>{{ trip.durationStr }}</td>
                          <td>{{ trip.distance }}</td>
                          <td class="no-header"></td>
                      </tr>
                  </tbody>
                  </table>
                </div>
                <div style="display: flex;align-items: center;justify-content: flex-end;">
                  <pagination-controls (pageChange)="pageChanged($event)"
                                          (pageBoundsCorrection)="pageChanged($event)"
                                          directionLinks="true"
                                          responsive="false"
                                          previousLabel='<'
                                          nextLabel='>'
                                          screenReaderPaginationLabel="Pagination"
                                          screenReaderPageLabel="page"
                                          screenReaderCurrentLabel="You're on page">
                  </pagination-controls>
                  <div style="margin-left:10px; padding-top: 7px;padding-bottom: 16px;">Page {{p}} of {{getPages()}}</div>
                </div>
              
              </div>
              
              <div class="map-container" *ngIf="isMapOpen">
                  <div class="map-container-info-bar" *ngIf="selected">
                      <div>
                          <img src="assets/images/left-arrow.svg" 
                              (click)="isMapOpen=false"
                              width="24" 
                              style="margin-right: 5px;" />
                      </div>
                      <div class="event-date">
                          <strong>{{ selected.date }}</strong>
                          <small>DATE</small>
                      </div>
                      <div class="event-start">
                          <strong>{{ selected.start }}</strong>
                          <small>START</small>
                      </div>
                      <div class="event-end">
                          <strong>{{ selected.end }}</strong>
                          <small>END</small>
                      </div>
                      <div class="event-duration">
                          <strong>{{ selected.durationStr }}</strong>
                          <small>DURATION</small>
                      </div>
                      <div class="event-distance">
                          <strong>{{ selected.distance }}</strong>
                          <small>KM</small>
                      </div>
                  </div>
                  <app-trip-map 
                      [selected]="selected"
                      [flattenLegend]="flattenLegend"
                      [filterLegends]="filterLegends"
                      style="flex: 1;"></app-trip-map>
                  <!-- <div id="map"></div> -->
              </div>
          </div>
        </ng-container>
        
      </div>
    </div>
  

</div>

<ng-template #rt let-r="result" let-t="term">
  <div class="text-left">
    <i style="width: 30px; text-align: center; color: silver" class="fas" [ngClass]="{'fa-users': r.prefix == 'Group', 'fa-user': r.prefix == 'User'}"></i>
    <ngb-highlight [result]="r.label" [term]="t"></ngb-highlight>
  </div>
</ng-template>
